import {
  Typography,
  Box,
  Divider,
  Grid,
} from "@mui/material";

const FsmRifasInfo = () => {
  return (
    <Grid item xs={12} xl={12} lg={12} sm={12} p={4}>
      <Box
        sx={{
          p: 4,
          borderRadius: 4,
          boxShadow: 3,
          backgroundColor: '#000',
          maxWidth: 600,
          margin: '0 auto',
        }}
      >
        <Typography
          variant="h6"
          fontWeight="bold"
          fontStyle="italic"
          color="white"
          gutterBottom
        >
          🥇 1er premio: RKV 200 + Electrodomésticos
        </Typography>

        <Divider sx={{ my: 2, backgroundColor: 'white' }} />
        <Typography
          variant="h6"
          fontWeight="bold"
          fontStyle="italic"
          color="white"
          gutterBottom
        >
          🥈 2do premio: Moto MD
        </Typography>

        <Divider sx={{ my: 2, backgroundColor: 'white' }} />
        <Typography
          variant="h6"
          fontWeight="bold"
          fontStyle="italic"
          color="white"
          gutterBottom
        >
          🥉 3er premio: 500 USD
        </Typography>

        <Divider sx={{ my: 2, backgroundColor: 'white' }} />
        <Typography
          variant="h6"
          fontWeight="bold"
          fontStyle="italic"
          color="white"
          gutterBottom
        >
          🎟️ 4 tickets premiados: 100 USD c/u
        </Typography>
      </Box>
    </Grid>
  );
};

export default FsmRifasInfo;
